export class Base {
  deserialize(obj: any) {
    Object.assign(this, obj);
    return this;
  }
}
